export default __webpack_public_path__ + "static/media/retarders.5c495814.svg";